import { FilterContext } from "~/providers/FilterProvider";
import type { ComponentProps } from "@ts/components";
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  type FC,
} from "react";

export type FilterSectionInputProps = ComponentProps & {
  handle?: string;
};

export type FilterSectionOutputProps = FilterSectionInputProps & {
  selectedCount: number | "";
  setShow: Dispatch<SetStateAction<boolean>>;
  show: boolean;
};

export const withFilterSection =
  (Component: FC<FilterSectionOutputProps>) =>
  ({ name = "FilterSection", handle, ...props }: FilterSectionInputProps) => {
    const { filtersSelected } = useContext(FilterContext);
    const [show, setShow] = useState(handle === "shop-by-style");

    const selectedCount = React.useMemo(() => {
      const filtersByHandle = filtersSelected.find(
        (item) => item.handle === handle,
      );

      if (!filtersByHandle?.value || filtersSelected?.value === null) {
        return null;
      }

      if (filtersByHandle?.value?.length === 0) {
        return "";
      }

      if (!Array.isArray(filtersByHandle.value)) {
        return 1;
      }

      return filtersByHandle?.value?.length;
    }, [filtersSelected]);

    Component.displayName = name;
    return (
      <Component
        {...props}
        selectedCount={selectedCount}
        setShow={setShow}
        show={show}
      />
    );
  };
